import { combineReducers, createReducer } from '@reduxjs/toolkit';
import { groupBy } from 'lodash/fp';
import { fetchResourceCategoriesSucceeded } from '../../resourceCategories/reducer';
import { CategoryImageAssignments } from './types';

const dataInitialState: CategoryImageAssignments['data'] = {};

const categoryImageAssignmentsDataSlice = createReducer(dataInitialState, (builder) => {
    builder.addCase(fetchResourceCategoriesSucceeded, (state, { payload: { imageAssignments } }) => ({
        ...state,
        ...groupBy('categoryId', imageAssignments),
    }));
});

export const categoryImageAssignmentsReducer = combineReducers({
    data: categoryImageAssignmentsDataSlice,
});
